"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardViewPaper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const LeaderboardViewPaper = ({ children, viewType, standingTabs, paperPosition, fadeIn, windowSize, isPWA, factor, backgroundColor = 'sepia.background', useFactorInHeight = true }) => {
    const isActive = standingTabs === viewType;
    // Calculate height with optional factor multiplier
    const heightOffset = useFactorInHeight
        ? (isPWA ? 160 * factor : 140 * factor)
        : (isPWA ? 160 : 140);
    if (!isActive)
        return null;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            width: '98%',
            height: '100%',
            padding: 0,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: backgroundColor,
            opacity: fadeIn ? 1 : 0,
            transition: 'opacity 0.4s ease-in-out',
            //border: '1px solid green',
            overflow: 'hidden',
            minHeight: 0,
        }, children: children }));
};
exports.LeaderboardViewPaper = LeaderboardViewPaper;
